// ------------------------------
// components/details/holdInvoiceBanner.tsx
// Persistent banner on every wallet page while any hold payment, in any
// vault, is waiting for a decision (zz-support-hold-invoices-fable.txt 10.6)
// ------------------------------

import { observer } from "mobx-react";
import React from "react";
import { Alert, Button, Group, Text } from "@mantine/core";
import { IconHourglass } from "@tabler/icons-react";
import { BobsWorkspace } from "../../stores/BobsWorkspace";
import { holdAmountSatoshis, minutesLeftLabel } from "../../helpers/holdInvoices";
import { useNow } from "./holdInvoiceCard";

const HoldInvoiceBanner = observer(
  ({ bobsWorkspace }: { bobsWorkspace: BobsWorkspace }) => {
    const now = useNow(15_000);
    const waiting = bobsWorkspace.undecidedHoldInvoicesAcrossBobs;
    if (waiting.length === 0) return null;

    const first = waiting[0];
    const totalSats = waiting.reduce(
      (sum, { hold }) => sum + holdAmountSatoshis(hold),
      0,
    );
    const msLeft = (first.hold.hold_decision_deadline_at ?? now) - now;
    const inAnotherVault = waiting.every(
      ({ bob }) => bob !== bobsWorkspace.selectedBob,
    );

    return (
      <Alert
        variant="light"
        color="red"
        icon={<IconHourglass size={18} />}
        styles={{ root: { background: "rgba(250, 82, 82, 0.10)" } }}
      >
        <Group justify="space-between" wrap="wrap" gap="xs">
          <Text fz="sm">
            {waiting.length === 1
              ? `1 payment of ${totalSats.toLocaleString()} sats is waiting for your decision`
              : `${waiting.length} payments (${totalSats.toLocaleString()} sats) are waiting for your decision`}
            {inAnotherVault && " in another vault"}
            {" · "}
            {waiting.length === 1 ? "" : "next "}
            {minutesLeftLabel(msLeft)}
          </Text>
          <Button
            size="xs"
            color="red"
            variant="light"
            onClick={() => bobsWorkspace.openHoldInvoiceDeepLink(first.hold.uuid)}
          >
            Open
          </Button>
        </Group>
      </Alert>
    );
  },
);

export default HoldInvoiceBanner;
